import { WidgetsTypeEnum } from "src/app/enums/widgets/widgets-type.enum";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";

export class ValdnWidgetsYearModel extends WidgetsAbstract {
    readonly icon: string = 'fact_check';
    readonly name: string = 'Year';
    readonly widgetType: WidgetsTypeEnum = WidgetsTypeEnum.VALDN_YEAR;
    template = 'year';
    readonly badge: string = 'VY';
    readonly placeholderClassName: string = 'valdn-placeholder';
    type: string = 'valdn';

    cloneFrom(origin: WidgetsAbstract) : WidgetsAbstract {
        return this;
    }    
}
